module.exports = __webpack_public_path__ + "static/media/lend.0916c5d8.svg";